module.exports = __webpack_public_path__ + "./images/b650ddfa6ff56e6dd8c6f9aee3c4521f.webp";